import { User } from "@/types/users/user";
import { UserWithoutTeachers } from "@/types/users/userWithoutTeachers";
import { TeacherActivity } from "@/types/activities/teacherActivity";
import ProfileHeader from "@/components/profile/ProfileHeaer";
import Ranking from "@/components/Ranking";

export const USER_PROFILE_IMAGE_PROPS = {
    size: 72,
    alt: "תמונת פרופיל",
    containerClassName: "user-profile-image-container",
    placeholderIconName: "person",
} as const;

interface UserProfileHeaderProps {
    user: User | UserWithoutTeachers;
    userActivities: TeacherActivity[];
    isLoadingUserActivities?: boolean;
    namePrefix?: string;
    nameSuffix?: string;
}

export default function UserProfileHeader({
    user,
    userActivities,
    isLoadingUserActivities,
    namePrefix,
    nameSuffix,
}: UserProfileHeaderProps) {
    const targetActivities = 5;
    const labels = [
        { index: 0, label: "חלוץ" },
        { index: 2, label: "מתלמד" },
        { index: 4, label: "מומחה ecosystem" },
    ];

    const completedActivities =
        userActivities?.filter(
            (activity) => activity.activity_status === "COMPLETED"
        ).length || 0;

    const userRankingLabel = (
        [...labels]
            .reverse()
            .find((label) => label.index + 1 <= completedActivities) ||
        labels[0]
    ).label.split(" ")[0];

    const title = [namePrefix, user.first_name, user.last_name, nameSuffix]
        .filter(Boolean)
        .join(" ");

    const subtitle = isLoadingUserActivities
        ? ""
        : `${userRankingLabel} - ${userActivities?.length || 0} אתגרים`;

    return (
        <ProfileHeader
            title={title}
            subtitle={subtitle}
            image={user.image || null}
            imageProps={USER_PROFILE_IMAGE_PROPS}
        >
            <Ranking
                completedActivities={completedActivities}
                targetActivities={targetActivities}
                labels={labels}
            />
        </ProfileHeader>
    );
}
